import { type ParentTaskType } from "@repo/api";

export const isFollowUpTask = (
  parentTaskType?: ParentTaskType,
  subTaskType?: string
) => {
  return parentTaskType === "appointment" && subTaskType === "followUp";
};
